import { ApiResponseStatus } from '@utils/types/global';

interface member {
    applicantGuid: Number,
    firstName: string,
    lastName: string,
    dateOfBirth: string, //(mm/dd/yyyy)
    effectiveAge: Number,
    aptcEligible: boolean,
    csrLevel: string,
    fullName: string
}
interface household {
    householdSize: Number,
    householdIncome: Number,
    fpl: Number,
    csrEligible: boolean,
    eligiblieForAptc: boolean,
    aptcDetails: any
    members: member[]
}
interface eligibilityFactors {
    notSeekingCoverage: boolean
    doesNotFinancialAssistance: boolean,
    noTaxFilingStatus: boolean,
    noIncomeWithinCsrThreshold: boolean,
    noCitizenNoLawfulPresence: boolean
}
export interface HouseholdInfoResponse {
    status: ApiResponseStatus,
    message: string | null,
    households: household[],
    comments: string,
    eligibilityDetails:IEligibilityDetails[],
    aptcEligibilityStartDate: string,
    aptcEligibilityEndDate: string,
    eligibilityFactors: eligibilityFactors
};
 interface IEligibilityDetails {
      memberName: string,
      age: number,
      income: number,
      householdSize: number,
      fpl: number,
      citizenOrQualifiedImmigrant: boolean,
      residency: string,
      deniedMedicaidChipInPast90Days: string,
      medicaid: string,
      chip: string,
      category: string,
      categoryIncomeThreshold: string,
      ineligibleReasonTextForChild: string|null,
      ineligibleReasonTextForPregnant: string|null,
      ineligibleReasonTextForParentCareTaker: string|null,
      ineligibleReasonTextForAdultGroup: string|null,
      ineligibleReasonTextForFormerFosterCare: string|null,
      ineligibleReasonTextForNonMagiMedicaid: string|null,
      ineligibleReasonTextForEmergencyMedicaid: string|null,
      ineligibleReasonTextForExchange: string|null
}
export interface IEnvironmentResponse {
    status: ApiResponseStatus;
    message: string | null;
    data: {
        configuration?: {
            exchangeName: string,
            portalStartYear: number
        },
        date: {
            currentTimestampUTC: string
        },
        user: {
            permissions: string[],
            encryptedUserId: string,
            encryptedHIOSId: string
        },
    }
};

export enum ScreenType {
    Member='Member',
    Household='Household',
    MedicaidMember='MedicaidMember',
}